import { createSlice } from '@reduxjs/toolkit';
import {
    setSocketConnectivity,
    setSocketInstance,
    addParticipant,
    removeParticipant,
    newMessageReceived,
    engagementCreated
} from '../actions/chatActions';

interface ChatState {
    isSocketConnected: boolean;
    socketInstance: any;
    messages: any[];
    participants: any[];
    isBotConnected: boolean;
    engagementParam: any;
}

const initialState: ChatState = {
    isSocketConnected: false,
    socketInstance: null,
    messages: [],
    participants: [],
    isBotConnected: false,
    engagementParam: null,
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setSocketConnectivity, (state, action) => {
                state.isSocketConnected = action.payload;
            })
            .addCase(setSocketInstance, (state, action) => {
                state.socketInstance = action.payload;
            })
            .addCase(newMessageReceived, (state, action) => {
                state.messages.push(action.payload);
                state.isBotConnected = action.payload?.senderParticipantType === "SYSTEM";
            })
            .addCase(addParticipant, (state, action) => {
                const participant = action.payload;
            
                // Ensure participant is defined before accessing its properties
                if (!participant) {
                    console.error("Participant data is undefined", action.payload);
                    return;
                }
            
                const currentTime = Date.now();
                state.participants.push(participant);
            
                if (participant.participantType === "AGENT") {
                    state.messages.push({
                        body: { elementText: { text: participant.displayName }, elementType: "text" },
                        senderType: "PARTICIPANT_ADDED",
                        lastUpdatedTimestamp: currentTime,
                    });
                }
            
                state.isBotConnected = false;
            })
            .addCase(removeParticipant, (state, action) => {
                const participant = action.payload;
                const currentTime = Date.now();

                // Ensure participant is defined before accessing its properties
                if (!participant) {
                    console.error("Participant data is undefined", action.payload);
                    return;
                }
                
                state.participants = state.participants.filter(
                    (p) => p.participantId !== participant.participantId
                );

                if (participant.participantType === "AGENT") {
                state.messages.push({
                    body: { elementText: { text: participant.displayName }, elementType: "text" },
                    senderType: "PARTICIPANT_REMOVED",
                    lastUpdatedTimestamp: currentTime,
                });
                }

                state.isBotConnected = false;
            })
            .addCase(engagementCreated, (state, action) => {
                if (action.payload?.eventType === "ENGAGEMENT_CREATED") {
                    state.engagementParam = { ...action.payload?.engagementParameters, engagement_id: action.payload?.engagementId };
                }
            });
    }
});

export default chatSlice.reducer;
